const series = (start, drift, vol, n, seed) => {
  let s = seed, p = start;
  const out = [];
  for (let i = 0; i < n; i++) {
    s = (s * 9301 + 49297) % 233280;
    const r = s / 233280 - 0.5;
    p = p + drift + r * vol;
    out.push(+p.toFixed(5));
  }
  return out;
};

export const SIGNALS = [
  {
    id: "FBS-2606-021",
    instrument: "EUR/USD",
    group: "Forex",
    direction: "Long",
    status: "Active",
    publishedAt: "2026-06-12T07:30:00Z",
    entry: "1.0810 – 1.0825",
    entryLevel: 1.0818,
    stop: 1.0762,
    targets: [1.0905, 1.0968],
    rr: "1:2.6",
    timeframe: "4H",
    horizon: "3–6 sessions",
    summary: "Dollar softness after cooler CPI print; pullback into 4H demand offers asymmetric long.",
    thesis: [
      "US May CPI printed 0.1% m/m against 0.2% expected, pushing front-end yields lower and widening the EUR-USD 2Y differential by 9bp in the euro's favour.",
      "Price has retraced into the 1.0810–1.0825 zone, which coincides with the 61.8% retracement of the June advance and the 4H 50-period mean.",
      "Positioning data shows speculative euro shorts remain crowded, providing fuel for a squeeze if 1.0870 is reclaimed.",
    ],
    invalidation: "A 4H close below 1.0762 would break structure and invalidate the demand thesis.",
    levels: [
      { label: "Resistance", value: 1.0968 }, { label: "Resistance", value: 1.0905 },
      { label: "Entry zone", value: 1.0818 }, { label: "Support", value: 1.0762 },
    ],
    timeline: [
      { at: "2026-06-12T07:30:00Z", event: "Idea published", note: "Limit orders in zone 1.0810–1.0825" },
      { at: "2026-06-12T13:10:00Z", event: "Entry filled", note: "Filled at 1.0819 during London afternoon" },
    ],
    outcome: null,
    chart: series(1.0790, 0.00012, 0.0022, 60, 11),
  },
  {
    id: "FBS-2606-020",
    instrument: "XAU/USD",
    group: "Metals",
    direction: "Short",
    status: "Target reached",
    publishedAt: "2026-06-10T09:15:00Z",
    entry: "2,362 – 2,370",
    entryLevel: 2366,
    stop: 2391,
    targets: [2328, 2302],
    rr: "1:2.5",
    timeframe: "Daily",
    horizon: "4–8 sessions",
    summary: "Gold failing at the May supply shelf as real yields firm; fade the retest.",
    thesis: [
      "10Y real yields have risen 14bp over the past week while gold has stalled below 2,370, a divergence that has preceded corrections in the current cycle.",
      "ETF flows turned negative for the third consecutive week, removing a key marginal buyer.",
      "A clean daily rejection candle at the supply shelf gives a tight structural stop.",
    ],
    invalidation: "Daily close above 2,391 would signal acceptance above supply.",
    levels: [
      { label: "Stop", value: 2391 }, { label: "Entry zone", value: 2366 },
      { label: "Target 1", value: 2328 }, { label: "Target 2", value: 2302 },
    ],
    timeline: [
      { at: "2026-06-10T09:15:00Z", event: "Idea published" },
      { at: "2026-06-10T14:40:00Z", event: "Entry filled", note: "Filled at 2,364" },
      { at: "2026-06-11T18:05:00Z", event: "Target 1 reached", note: "Partial profit taken; stop moved to entry" },
    ],
    outcome: null,
    chart: series(2372, -0.9, 9, 60, 7),
  },
  {
    id: "FBS-2606-019",
    instrument: "GBP/USD",
    group: "Forex",
    direction: "Long",
    status: "Pending",
    publishedAt: "2026-06-11T16:00:00Z",
    entry: "1.2660 – 1.2680",
    entryLevel: 1.2670,
    stop: 1.2615,
    targets: [1.2770, 1.2830],
    rr: "1:2.2",
    timeframe: "4H",
    horizon: "1–2 weeks",
    summary: "BoE repricing stalls; cable pullback toward prior breakout level sets up continuation long.",
    thesis: [
      "Markets have pared BoE August cut odds to 38% after sticky services inflation, supporting sterling on dips.",
      "The 1.2660–1.2680 band was the May range high and has not yet been retested as support.",
    ],
    invalidation: "4H close below 1.2615.",
    levels: [
      { label: "Target 2", value: 1.283 }, { label: "Target 1", value: 1.277 },
      { label: "Entry zone", value: 1.267 }, { label: "Stop", value: 1.2615 },
    ],
    timeline: [{ at: "2026-06-11T16:00:00Z", event: "Idea published", note: "Awaiting pullback into zone" }],
    outcome: null,
    chart: series(1.2740, -0.00008, 0.0019, 60, 5),
  },
  {
    id: "FBS-2606-018",
    instrument: "US Tech 100",
    group: "Indices",
    direction: "Long",
    status: "Closed",
    publishedAt: "2026-06-05T13:45:00Z",
    entry: "18,420 – 18,480",
    entryLevel: 18450,
    stop: 18240,
    targets: [18780, 19050],
    rr: "1:2.9",
    timeframe: "Daily",
    horizon: "1–2 weeks",
    summary: "Semiconductor leadership re-asserting; buy the post-NFP dip into the 20-day mean.",
    thesis: [
      "Breadth within the index improved materially with 71% of constituents above their 50-day average.",
      "Post-NFP dip provided a liquidity sweep of the prior week's low before reclaiming the 20-day mean.",
    ],
    invalidation: "Daily close below 18,240.",
    levels: [
      { label: "Target 2", value: 19050 }, { label: "Target 1", value: 18780 },
      { label: "Entry zone", value: 18450 }, { label: "Stop", value: 18240 },
    ],
    timeline: [
      { at: "2026-06-05T13:45:00Z", event: "Idea published" },
      { at: "2026-06-05T15:30:00Z", event: "Entry filled", note: "18,462" },
      { at: "2026-06-09T19:00:00Z", event: "Target 1 reached" },
      { at: "2026-06-11T20:00:00Z", event: "Target 2 reached", note: "Position closed in full" },
    ],
    outcome: { result: "Win", pips: "+588 pts", r: "+2.9R" },
    chart: series(18380, 11, 70, 60, 3),
  },
  {
    id: "FBS-2606-017",
    instrument: "USD/JPY",
    group: "Forex",
    direction: "Short",
    status: "Stopped",
    publishedAt: "2026-06-03T08:00:00Z",
    entry: "157.20 – 157.60",
    entryLevel: 157.4,
    stop: 158.35,
    targets: [155.8, 154.6],
    rr: "1:1.7",
    timeframe: "4H",
    horizon: "3–5 sessions",
    summary: "Intervention-risk zone with diverging momentum; tactical fade of the 157 handle.",
    thesis: [
      "Price entered the zone where MoF intervention occurred in late April, and verbal warnings had intensified.",
      "4H momentum diverged across three consecutive highs.",
    ],
    invalidation: "4H close above 158.35.",
    levels: [
      { label: "Stop", value: 158.35 }, { label: "Entry zone", value: 157.4 },
      { label: "Target 1", value: 155.8 }, { label: "Target 2", value: 154.6 },
    ],
    timeline: [
      { at: "2026-06-03T08:00:00Z", event: "Idea published" },
      { at: "2026-06-03T11:20:00Z", event: "Entry filled", note: "157.31" },
      { at: "2026-06-04T02:45:00Z", event: "Stop triggered", note: "Tokyo session squeeze through 158.35" },
    ],
    outcome: { result: "Loss", pips: "−104 pips", r: "−1.0R" },
    chart: series(157.0, 0.03, 0.28, 60, 9),
  },
  {
    id: "FBS-2606-016",
    instrument: "AUD/USD",
    group: "Forex",
    direction: "Long",
    status: "Active",
    publishedAt: "2026-06-09T22:30:00Z",
    entry: "0.6610 – 0.6625",
    entryLevel: 0.6618,
    stop: 0.6572,
    targets: [0.6690, 0.6740],
    rr: "1:2.4",
    timeframe: "Daily",
    horizon: "1–3 weeks",
    summary: "RBA on hold with hawkish bias; iron ore stabilising supports an Aussie recovery.",
    thesis: [
      "RBA minutes reiterated that a hike was discussed, while markets still price cuts — asymmetry favours AUD.",
      "Iron ore has based above $105 after a 20% correction, stabilising terms-of-trade expectations.",
    ],
    invalidation: "Daily close below 0.6572.",
    levels: [
      { label: "Target 2", value: 0.674 }, { label: "Target 1", value: 0.669 },
      { label: "Entry zone", value: 0.6618 }, { label: "Stop", value: 0.6572 },
    ],
    timeline: [
      { at: "2026-06-09T22:30:00Z", event: "Idea published" },
      { at: "2026-06-10T03:15:00Z", event: "Entry filled", note: "0.6616" },
    ],
    outcome: null,
    chart: series(0.6605, 0.00006, 0.0012, 60, 13),
  },
  {
    id: "FBS-2606-015",
    instrument: "Germany 40",
    group: "Indices",
    direction: "Short",
    status: "Closed",
    publishedAt: "2026-05-28T10:00:00Z",
    entry: "18,720 – 18,790",
    entryLevel: 18750,
    stop: 18960,
    targets: [18420, 18200],
    rr: "1:2.6",
    timeframe: "Daily",
    horizon: "1–2 weeks",
    summary: "Record highs on narrowing breadth into ECB; fade the extension.",
    thesis: ["Only 44% of DAX constituents were above their 20-day average at the index high — a breadth divergence."],
    invalidation: "Daily close above 18,960.",
    levels: [
      { label: "Stop", value: 18960 }, { label: "Entry zone", value: 18750 },
      { label: "Target 1", value: 18420 }, { label: "Target 2", value: 18200 },
    ],
    timeline: [
      { at: "2026-05-28T10:00:00Z", event: "Idea published" },
      { at: "2026-05-28T14:00:00Z", event: "Entry filled" },
      { at: "2026-06-02T15:30:00Z", event: "Target 1 reached" },
      { at: "2026-06-04T09:00:00Z", event: "Closed manually", note: "Closed at 18,310 ahead of ECB" },
    ],
    outcome: { result: "Win", pips: "+440 pts", r: "+2.1R" },
    chart: series(18790, -9, 60, 60, 17),
  },
  {
    id: "FBS-2606-014",
    instrument: "XAG/USD",
    group: "Metals",
    direction: "Long",
    status: "Target reached",
    publishedAt: "2026-06-06T12:00:00Z",
    entry: "29.40 – 29.70",
    entryLevel: 29.55,
    stop: 28.6,
    targets: [30.8, 31.9],
    rr: "1:2.5",
    timeframe: "Daily",
    horizon: "2–3 weeks",
    summary: "Silver's gold ratio compressing; industrial demand narrative intact.",
    thesis: ["Gold/silver ratio broke below 80 for the first time since 2021, historically a regime signal for silver outperformance."],
    invalidation: "Daily close below 28.60.",
    levels: [
      { label: "Target 2", value: 31.9 }, { label: "Target 1", value: 30.8 },
      { label: "Entry zone", value: 29.55 }, { label: "Stop", value: 28.6 },
    ],
    timeline: [
      { at: "2026-06-06T12:00:00Z", event: "Idea published" },
      { at: "2026-06-06T16:00:00Z", event: "Entry filled" },
      { at: "2026-06-11T13:20:00Z", event: "Target 1 reached", note: "Stop raised to 29.90" },
    ],
    outcome: null,
    chart: series(29.3, 0.03, 0.22, 60, 21),
  },
  {
    id: "FBS-2606-013",
    instrument: "US 500",
    group: "Indices",
    direction: "Long",
    status: "Active",
    publishedAt: "2026-06-11T20:30:00Z",
    entry: "5,280 – 5,300",
    entryLevel: 5290,
    stop: 5236,
    targets: [5365, 5410],
    rr: "1:2.2",
    timeframe: "4H",
    horizon: "1–2 weeks",
    summary: "Post-FOMC drift higher with vol compression; buy the first 4H pullback.",
    thesis: ["VIX term structure re-steepened post-FOMC, a backdrop that has favoured upward drift in the current regime."],
    invalidation: "4H close below 5,236.",
    levels: [
      { label: "Target 2", value: 5410 }, { label: "Target 1", value: 5365 },
      { label: "Entry zone", value: 5290 }, { label: "Stop", value: 5236 },
    ],
    timeline: [{ at: "2026-06-11T20:30:00Z", event: "Idea published" }, { at: "2026-06-12T01:00:00Z", event: "Entry filled", note: "5,288" }],
    outcome: null,
    chart: series(5270, 1.4, 14, 60, 23),
  },
];

export const getSignal = (id) => SIGNALS.find((s) => s.id === id);
